module.exports = __webpack_public_path__ + "static/media/cpg_ctv_nbc_video.5a7655d5.png";